export default {
  CA: "CA",
  US: "US",
};
